var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Cube = function Cube(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.51 2.128a1 1 0 0 1 .98 0l7.985 4.492a.995.995 0 0 1 .525.9v8.98a1 1 0 0 1-.51.872l-7.983 4.49a.996.996 0 0 1-.504.138H11.99a.995.995 0 0 1-.495-.136L3.51 17.372A1 1 0 0 1 3 16.5V7.515a.994.994 0 0 1 .522-.894l7.988-4.493ZM5 9.21v6.705l6 3.375v-6.705L5 9.21Zm7 1.643L6.04 7.5 12 4.147 17.96 7.5 12 10.853Zm7 5.062-6 3.375v-6.705l6-3.375v6.705Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Cube;